import { fetchOwner, fetchUserBilling } from "../../utils";
import { setOwner, setUser } from "../../store/slices/ownerSlice";
import { setStoredOwner } from "../../utils/authStorage";

type RefreshBillingSessionArgs = {
  owner: any;
  currentUser: any;
  dispatch: any;
};

export const refreshBillingSession = async ({
  owner,
  currentUser,
  dispatch,
}: RefreshBillingSessionArgs) => {
  const resolvedUserId =
    (typeof currentUser?.userId === "string" && currentUser.userId) ||
    (typeof owner?.userId === "string" && owner.userId) ||
    "";
  const resolvedEmail =
    (typeof owner?.email === "string" && owner.email.trim()) ||
    (typeof currentUser?.email === "string" && currentUser.email.trim()) ||
    "";

  if (owner?._id) {
    const updatedOwner = await fetchOwner(owner._id);
    dispatch(setOwner(updatedOwner));
    setStoredOwner(updatedOwner);
    if (resolvedUserId) {
      const billingData = await fetchUserBilling({ userId: resolvedUserId }).catch(() => null);
      if (billingData?.userBilling) {
        dispatch(
          setUser({
            ...(currentUser || {}),
            userId: billingData?.userId || resolvedUserId,
            email: billingData?.email || resolvedEmail || currentUser?.email || "",
            userBilling: billingData.userBilling,
          })
        );
      }
    }
    return updatedOwner;
  }

  if (!resolvedUserId) return null;

  const billingData = await fetchUserBilling({ userId: resolvedUserId });
  const mergedSessionOwner = {
    ...(owner || {}),
    email: billingData?.email || resolvedEmail || "",
    userId: billingData?.userId || resolvedUserId,
    linkedOwners: Array.isArray(owner?.linkedOwners) ? owner.linkedOwners : [],
    planhistory: Array.isArray(billingData?.userBilling?.planhistory)
      ? billingData.userBilling.planhistory
      : [],
    stripeCustomerId: billingData?.userBilling?.stripeCustomerId || "",
    PaymentTries: Number(billingData?.userBilling?.PaymentTries || 0),
    stripePaymentFailure: billingData?.userBilling?.stripePaymentFailure || null,
    pendingPlanChange: billingData?.userBilling?.pendingPlanChange || null,
  } as any;

  dispatch(setOwner(mergedSessionOwner));
  setStoredOwner(mergedSessionOwner);
  if (billingData?.userBilling) {
    dispatch(
      setUser({
        ...(currentUser || {}),
        userId: billingData?.userId || resolvedUserId,
        email: billingData?.email || resolvedEmail || currentUser?.email || "",
        userBilling: billingData.userBilling,
      })
    );
  }
  return mergedSessionOwner;
};
